import { render, staticRenderFns } from "./ImportedPeople.vue?vue&type=template&id=34cf7876&scoped=true&"
import script from "./ImportedPeople.vue?vue&type=script&lang=js&"
export * from "./ImportedPeople.vue?vue&type=script&lang=js&"
import style0 from "./style.scss?vue&type=style&index=0&id=34cf7876&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34cf7876",
  null
  
)

export default component.exports